import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Procedure, ProviderSettings } from '@dataTypes/procedureSettings.type'
import {
  getAllProcedures,
  addProcedure,
  updateProcedure,
  removeProcedure,
  getProviderSettings,
  saveProviderSettings,
  // getProvidersList,
  updateProviderSettingsDraft,
} from '@store/actions/procedureSettings.action'
import { Provider } from '@dataTypes/ProviderInfo.types'

type ProcedureState = {
  procedures: Procedure[]
  providerSettings: ProviderSettings
  draftProviderSettings: ProviderSettings
  initialDraftProviderSettings: ProviderSettings | null
  providers: Provider[]
  loading: boolean
  error: string | null
}

const initialState: ProcedureState = {
  procedures: [],
  providerSettings: { payTo: '', billingTo: '', referring: '', rendering: '' },
  draftProviderSettings: {
    payTo: '',
    billingTo: '',
    referring: '',
    rendering: '',
  },
  initialDraftProviderSettings: null,
  providers: [],
  loading: false,
  error: null,
}

const procedureSettingsSlice = createSlice({
  name: 'procedureSettings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllProcedures.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        getAllProcedures.fulfilled,
        (state, action: PayloadAction<Procedure[]>) => {
          state.loading = false
          state.procedures = action.payload
        },
      )
      .addCase(getAllProcedures.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

      .addCase(
        addProcedure.fulfilled,
        (state, action: PayloadAction<Procedure>) => {
          state.procedures.push(action.payload)
        },
      )

      .addCase(
        updateProcedure.fulfilled,
        (state, action: PayloadAction<Procedure>) => {
          const index = state.procedures.findIndex(
            (procedure) => procedure.code === action.payload.code,
          )
          if (index !== -1) {
            state.procedures[index] = {
              ...state.procedures[index],
              ...action.payload,
            }
          }
        },
      )

      .addCase(
        removeProcedure.fulfilled,
        (state, action: PayloadAction<string>) => {
          state.procedures = state.procedures.filter(
            (procedure) => procedure.code !== action.payload,
          )
        },
      )

      .addCase(getProviderSettings.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        getProviderSettings.fulfilled,
        (state, action: PayloadAction<ProviderSettings>) => {
          state.loading = false
          state.providerSettings = action.payload
          state.draftProviderSettings = action.payload
        },
      )
      .addCase(getProviderSettings.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

      .addCase(saveProviderSettings.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        saveProviderSettings.fulfilled,
        (state, action: PayloadAction<ProviderSettings>) => {
          state.loading = false
          state.providerSettings = action.payload
          state.draftProviderSettings = action.payload
        },
      )
      .addCase(saveProviderSettings.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

      // .addCase(getProvidersList.pending, (state) => {
      //   state.loading = true
      //   state.error = null
      // })
      // .addCase(
      //   getProvidersList.fulfilled,
      //   (state, action: PayloadAction<Provider[]>) => {
      //     state.loading = false
      //     state.providers = action.payload
      //   },
      // )
      // .addCase(getProvidersList.rejected, (state, action) => {
      //   state.loading = false
      //   state.error = action.payload as string
      // })

      .addCase(
        updateProviderSettingsDraft,
        (state, action: PayloadAction<ProviderSettings>) => {
          state.draftProviderSettings = action.payload
        },
      )
  },
})

export default procedureSettingsSlice.reducer
